export enum UKEnergyProduct {
  BASELOAD = 'baseload',
  OFFPEAK = 'offpeak',
  PEAK = 'peak',
  OVERNIGHT = 'overnight',
  EXTENDED_PEAK = 'extendedPeak',
  EFA1 = 'efa1',
  EFA2 = 'efa2',
  EFA3 = 'efa3',
  EFA4 = 'efa4',
  EFA5 = 'efa5',
  EFA6 = 'efa6',
  EFA1A = 'efa1A',
  EFA1B = 'efa1B',
  EFA2A = 'efa2A',
  EFA2B = 'efa2B',
  EFA3A = 'efa3A',
  EFA3B = 'efa3B',
  EFA4A = 'efa4A',
  EFA4B = 'efa4B',
  EFA5A = 'efa5A',
  EFA5B = 'efa5B',
  EFA6A = 'efa6A',
  EFA6B = 'efa6B',
  SP1 = 'sp1',
  SP2 = 'sp2',
  SP3 = 'sp3',
  SP4 = 'sp4',
  SP5 = 'sp5',
  SP6 = 'sp6',
  SP7 = 'sp7',
  SP8 = 'sp8',
  SP9 = 'sp9',
  SP10 = 'sp10',
  SP11 = 'sp11',
  SP12 = 'sp12',
  SP13 = 'sp13',
  SP14 = 'sp14',
  SP15 = 'sp15',
  SP16 = 'sp16',
  SP17 = 'sp17',
  SP18 = 'sp18',
  SP19 = 'sp19',
  SP20 = 'sp20',
  SP21 = 'sp21',
  SP22 = 'sp22',
  SP23 = 'sp23',
  SP24 = 'sp24',
  SP25 = 'sp25',
  SP26 = 'sp26',
  SP27 = 'sp27',
  SP28 = 'sp28',
  SP29 = 'sp29',
  SP30 = 'sp30',
  SP31 = 'sp31',
  SP32 = 'sp32',
  SP33 = 'sp33',
  SP34 = 'sp34',
  SP35 = 'sp35',
  SP36 = 'sp36',
  SP37 = 'sp37',
  SP38 = 'sp38',
  SP39 = 'sp39',
  SP40 = 'sp40',
  SP41 = 'sp41',
  SP42 = 'sp42',
  SP43 = 'sp43',
  SP44 = 'sp44',
  SP45 = 'sp45',
  SP46 = 'sp46',
  SP47 = 'sp47',
  SP48 = 'sp48',
  SP49 = 'sp49',
  SP50 = 'sp50',
  HR1 = 'hr1',
  HR2 = 'hr2',
  HR3 = 'hr3',
  HR3x = 'hr3x',
  HR4 = 'hr4',
  HR5 = 'hr5',
  HR6 = 'hr6',
  HR7 = 'hr7',
  HR8 = 'hr8',
  HR9 = 'hr9',
  HR10 = 'hr10',
  HR11 = 'hr11',
  HR12 = 'hr12',
  HR13 = 'hr13',
  HR14 = 'hr14',
  HR15 = 'hr15',
  HR16 = 'hr16',
  HR17 = 'hr17',
  HR18 = 'hr18',
  HR19 = 'hr19',
  HR20 = 'hr20',
  HR21 = 'hr21',
  HR22 = 'hr22',
  HR23 = 'hr23',
  HR24 = 'hr24',
  NOT_APPLICABLE = 'notApplicable',
}
